export default __webpack_public_path__ + "static/media/filter_icon_accessibility_room.288952d3.svg";